import { useOverlapOvertimeContext } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/context";
import { EMetricType } from "app/pages/website-analysis/audience-overlap/OverlapOverTime/types";
import { LegendBullet } from "@similarweb/ui-components";
import styled from "styled-components";

const { TOTAL, PER_SITE } = EMetricType;

const LegendsContainer = styled.div`
    width: 221px;
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    padding: 8px;
`;

export const Legends = () => {
    const { selectedMetric, chartDataAll } = useOverlapOvertimeContext();
    if (selectedMetric === TOTAL || !chartDataAll || !chartDataAll[PER_SITE]) {
        return null;
    }
    const chartData = chartDataAll[PER_SITE];
    return (
        <LegendsContainer>
            {chartData.map(({ name, color }, index) => {
                return (
                    <LegendBullet
                        key={index}
                        text={name}
                        labelColor={color}
                    />
                );
            })}
        </LegendsContainer>
    );
};
